module.exports = "<div class=modal-header> <h3 class=modal-title>{{confirmObject.title}}</h3> </div> <div class=modal-body style=font-size:20px> {{confirmObject.message}} </div> <div class=modal-footer> <button class=\"btn btn-primary\" ng-click=confirmed()>{{confirmObject.button}}</button> <button class=\"btn btn-warning\" ng-click=cancelled()>Cancel</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/views/confirmModal.html
// module id = 47
// module chunks = 0